// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__Ys9V9","info":"UpdateTermsInfo_info__2VJ-4"};